// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3LTMD","column":"style_column__22ZYx","row":"style_row__3R1Om"};